export var ContentTaskPriority;
(function (ContentTaskPriority) {
    ContentTaskPriority[ContentTaskPriority["LOW"] = 10] = "LOW";
    ContentTaskPriority[ContentTaskPriority["MEDIUM"] = 20] = "MEDIUM";
    ContentTaskPriority[ContentTaskPriority["HIGH"] = 30] = "HIGH";
})(ContentTaskPriority || (ContentTaskPriority = {}));
//# sourceMappingURL=content-task-priority.enum.js.map